import { getMPDataWithParams } from 'src/mentor/services'


export const MENTOR_WEBINARS_PAGE_VIEWS = {
  VIEW_ALL_EVENTS: 'viewAllEvents',
  VIEW_SCHEDULED_EVENTS: 'viewScheduledEvents',
}

export async function fetchWebinarsForMentors(page = 0) {
  const resp = await getMPDataWithParams('/api/secure/teacher/webinar/all/page', { page })
  if (resp?.status === 200) {
    return resp?.data?.content
  }
}
